 
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigurationClientService } from '../client/configuration-client.service';
import { ApiClient } from '../client/api-client';
import { Assistant, UserProfile } from '@app-libs/model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InstructionsApiService extends ApiClient {
  
  override get baseUrl(): string {
    return this.config.getBackendAPIUrl() + '/instructions';
  }

  constructor(config: ConfigurationClientService, http: HttpClient) {
    super(config, http);
  }

  /**
   * Builds instructions for a specific assistant and user profile.
   * @param assistant The assistant object
   * @param profile The user profile object
   * @returns Observable with the generated instructions string
   */
  buildAssistantInstructions(assistant: Assistant, profile: UserProfile): Observable<string> {
    return this.http.post(`${this.baseUrl}/build-assistant-instructions`, { assistant, profile }, { responseType: 'text' });
  }

  /**
   * Builds a welcome message for a specific assistant and user profile.
   * @param assistant The assistant object
   * @param profile The user profile object
   * @returns Observable with the generated welcome message
   */
  buildWelcomeMessage(assistant: Assistant, profile: UserProfile): Observable<string> {
    return this.http.post(`${this.baseUrl}/build-welcome-message`, { assistant, profile }, { responseType: 'text' });
  }

  /**
   * Assembles instructions from prompt data for a specific promptId.
   * @param promptId The ID of the prompt to assemble instructions for
   * @returns Observable with the assembled instructions string
   */
  assembleInstructions(promptId: string): Observable<string> {
    return this.http.post(`${this.baseUrl}/assemble-instructions`, { promptId }, { responseType: 'text' });
  }

  /**
   * Fetches snippets for a specific promptId.
   * @param promptId The ID of the prompt to fetch snippets for
   * @returns Observable with the fetched snippets
   */
  fetchSnippetsForPrompt(promptId: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/fetch-snippets`, { promptId });
  }
}